import { start } from '@jutro/app';
import {
    BrowserRouter
} from 'react-router-dom';
import { loadGtag  } from '@jutro/events';
import  { BrandingService } from '@xengage/gw-portals-branding-js'
import { MLLocaleService } from 'ml-portals-services-react';
import { 
    loadAdobeTM, 
    loadIECustomEventCompatibility, 
    loadSegmentIO, 
    loadWhatFix,
    subscribeToEvents
} from 'ml-portals-util-js'
import 'regenerator-runtime';

// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';

import App from './app/App';

import { configureLegacyComponentMap } from '@jutro/legacy/uiconfig';
configureLegacyComponentMap();

const { trackingConfig = {}, authentication = {}, runtimeEnv = '' } = appConfig;

const gaTrackingId = trackingConfig.GA_TRACKING_ID;
const gTagMeasurementId = runtimeEnv === 'prod' ? trackingConfig.GTM_TRACKING_ID_prod : trackingConfig.GTM_TRACKING_ID;
const adobeTMAssetURL = runtimeEnv === 'prod' ? trackingConfig.ADOBETM_ASSET_URL_prod : trackingConfig.ADOBETM_ASSET_URL;
const segmentIOTracking = runtimeEnv === 'prod' ? trackingConfig.SEGMENTIO_TRACKING_KEY_prod : trackingConfig.SEGMENTIO_TRACKING_KEY;


if(gTagMeasurementId){
//    loadGtag(gTagMeasurementId);
}
if(adobeTMAssetURL){
    loadAdobeTM(adobeTMAssetURL)
}
/*if (gaTrackingId) {
    const ga = loadGA(gaTrackingId);
    ga('require', 'ecommerce')
}*/
if(adobeTMAssetURL || gTagMeasurementId){
    loadIECustomEventCompatibility();
}
if(segmentIOTracking){
    loadSegmentIO(segmentIOTracking);
}
loadWhatFix('PE');
subscribeToEvents('GPA');

const storeUrlSearchParameters = () => {
    const windowUrl  = window.location.search
    const params = new URLSearchParams(windowUrl.toLowerCase());

    if (params.has('fromsource', 'iaportal')) {
        sessionStorage.setItem('fromIAPortal', true);
    }
}

storeUrlSearchParameters();

const silentRedirectPath = appConfig?.authentication?.servers?.okta?.JUTRO_AUTH_SILENT_REDIRECT_PATH;
    const silentLoginPath = appConfig?.authentication?.servers?.okta?.JUTRO_AUTH_SILENT_LOGIN_PATH; 

if (window.self === window.top) {
        const theBody = document.getElementsByTagName('body')[0];

        theBody.style.display = 'block';
    } else if ((!silentLoginPath || !window.self.location.pathname.endsWith(silentLoginPath)) &&
    (!silentRedirectPath || !window.self.location.pathname.endsWith(silentRedirectPath))) {
        const { host, protocol } = new URL(window.top.location);
        const root = `${protocol}//${host}`;
        const rootPath = process.env.PUBLIC_PATH;

        window.top.location = new URL(rootPath, root);
    }

start(App, {
    rootId: 'root',

    // themeConfig: BrandingService.getBrandingTheme(),
    messageLoader: MLLocaleService.loadMessages,

    coreMessageLoader: MLLocaleService.loadCoreMessages,
    refreshOnLocaleChange: true,

    routerBasename: '/producer-engage',
    config: [authentication.servers.okta],

    onInit: () => {
        MLLocaleService.register();
    },

    Router: BrowserRouter,
    //g11nStore: G11nstore(),

    appName: {
        id: 'digital.appName',
        defaultMessage: 'ProducerEngage'
    },

    appDescription: 'ProducerEngage',
});
